module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"inviteTextHeader":"Отправьте кандидатам ссылку на видео-интервью любым удобным способом (job-сайт, мессенджер и т.п.).","textAreaHeader":"Приглашение","copyNotificationText":"Скопировать текст приглашения","changeTemplate":"Редактировать шаблон"}}')
  delete Component.options._Ctor
}
